import React from 'react';
import projectImage from '../img/P8.png';
import Navbar from './Navbar';
import { motion } from "framer-motion";
import { FaGithub, FaFigma } from "react-icons/fa";
import { Link } from "react-router-dom";

const Pro4 = () => {
  return (
    <div>
      <Navbar />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        id='about'
        className="mx-auto px-4 md:px-20"
      >
        <h2 className="text-4xl sm:text-4xl font-bold pl-4 pt-20">Project Title : Company Management System UI/UX</h2>

        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center h-full py-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="h-75 w-75 ml-4 mr-4 pr-4"
          >
            <img
              src={projectImage}
              alt="Project Screenshot"
              className="mx-auto w-full shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col justify-center h-full   "
          >
            <div className="items-center justify-center">
              <h2 className="text-3xl sm:text-4xl font-bold pl-4">Key tools and technologies:</h2>
              <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2">
              <li className="pl-10">
           MediaPipe 
          </li>
          <li className="pl-10">
           Tkinter
          </li>
          <li className="pl-10">
          OpenCV          
          </li>              </ul>
          <h2 className="text-3xl sm:text-3xl font-bold  pl-10 pb-5"> Algorithums :</h2>

        <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2 ">
          <li className="pl-10">
          Logistic Regression           
          </li>
          <li className="pl-10">
          Random Forest           
          </li>
         
          
        </ul>
        <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2 ">
          
          <li className="pl-10">
          Ridge Classification           
          </li>
          <li className="pl-10">
          Gradient Boosting           
          </li>
          
        </ul>
            </div>

            <div className="items-center justify-center">
              <ul className="flex justify-center pb-5 text-xl sm:text-2xl font-bold">
               
               
              </ul>
            </div>
          </motion.div>
        </div>

        <h1 className="text-4xl sm:text-3xl font-bold pt-10 pl-4">Project Description:</h1>
        <div className="px-4 md:px-20">
          <p className="py-4">
          This capstone project is focused on creating a Yoga Pose Recognition System with real-time accuracy and feedback for users. The objective is to address the limitations observed in existing systems by incorporating Media Pipe for feature extraction and ML models for pose detection. By using a pipeline structure, four models, namely Logistic Regression, Random Forest, Ridge Classifier, and Gradient Booster, were trained and tested. Ultimately, Logistic Regression emerged as the most robust and effective algorithm, leveraging its multi-class classification capabilities with softmax regression.

<br/>To enhance performance and simplify the dataset, face coordinates were removed during feature extraction. Additionally, to mitigate class imbalance issues, the team implemented Oversampling and Undersampling techniques, further refining the model's accuracy and reliability.

<br/>The proposed system aims to provide detailed and specific feedback for each body part in real time, thereby improving the user experience and enabling precise adjustments during yoga practice. The utilization of advanced techniques and models allows for enhanced accuracy, making this Yoga Pose Recognition System an innovative and valuable tool for yoga enthusiasts and practitioners.

<br/>Throughout the project, the team worked collaboratively, leveraging their collective expertise and problem-solving skills to overcome challenges and achieve exceptional results. The successful implementation of this capstone project underscores the group's commitment to delivering a cutting-edge solution for yoga pose recognition and feedback, showcasing their dedication to excellence in their field.</p>

          {/* <div>
            <button
              type="button"
              className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
            >
              Video Link
            </button>
          </div> */}
        </div>
      </motion.div>
    </div>
  );
};

export default Pro4;
